import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MoonFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18767 2.21673C9.29149 2.32052 9.36212 2.45281 9.39061 2.59683C9.41909 2.74084 9.40414 2.89006 9.34766 3.02556C8.89615 4.10915 8.66452 5.27167 8.66622 6.44556C8.66622 8.80287 9.60266 11.0636 11.2695 12.7305C12.9364 14.3974 15.1972 15.3338 17.5545 15.3338C18.7284 15.3355 19.8909 15.1039 20.9745 14.6524C21.1099 14.596 21.259 14.5811 21.4029 14.6095C21.5468 14.6379 21.679 14.7085 21.7828 14.8121C21.8866 14.9158 21.9572 15.0479 21.9858 15.1918C22.0144 15.3356 21.9996 15.4848 21.9434 15.6202C21.1553 17.5097 19.8257 19.1237 18.1221 20.259C16.4184 21.3943 14.4169 22.0001 12.3697 22C6.64265 22 2 17.3574 2 11.6304C2 7.31661 4.6339 3.6191 8.37982 2.05674C8.51519 2.00047 8.66422 1.98563 8.80803 2.01411C8.95184 2.04259 9.08396 2.11311 9.18767 2.21673Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

MoonFilledIcon.displayName = 'MoonFilledIcon';
